import parseCookieTransfer from '../utils/parseCookieState';

export interface NativeState {
  Theme?: 'light' | 'dark';
}

export const getNativeState = () => {
  return parseCookieTransfer((cookies) => ({
    Theme: isNativeThemeType(cookies.Theme) ? cookies.Theme : undefined,
  }));
};

export const isNativeThemeType = (theme: any): theme is NativeState['Theme'] =>
  theme === 'light' || theme === 'dark';
